module.exports = __webpack_public_path__ + "img/icon.bad82ea6.svg";